import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '@app/shared';

import {accountState} from '@app/account/account.route';
import {PasswordResetInitComponent} from '@app/account/password-reset/init/password-reset-init.component';
import {PasswordResetFinishComponent} from '@app/account/password-reset/finish/password-reset-finish.component';

@NgModule({
  declarations: [PasswordResetInitComponent, PasswordResetFinishComponent],
  imports: [SharedModule, RouterModule.forChild(accountState)],
  entryComponents: [PasswordResetInitComponent, PasswordResetFinishComponent],
})
export class AccountModule {}
